import { css } from "@emotion/react";
import { CSS_COLORS } from "../../../../styles/styles-css-variables";

export const DotNavigation: React.FC<{
  items: Array<unknown>;
  visibleIdx: number;
  setVisibleIdx: (idx: number) => void;
}> = ({ items, visibleIdx, setVisibleIdx }) => {
  return (
    <div
      css={css`
        margin: 0 8px;
      `}
    >
      {items.map((_, idx) => (
        <button
          className={idx === visibleIdx ? "selected" : undefined}
          key={idx}
          onClick={() => setVisibleIdx(idx)}
          css={css`
            width: 32px;
            height: 32px;
            padding: 10px;
          `}
        >
          <span css={spanStyle} />
        </button>
      ))}
    </div>
  );
};

const spanStyle = css`
  display: block;
  width: 100%;
  height: 100%;

  border-radius: 100%;

  border-width: 1px;
  border-style: solid;
  border-color: ${CSS_COLORS.Grey0};

  background-color: ${CSS_COLORS.White};
  .selected & {
    background-color: ${CSS_COLORS.Green};
  }
`;
